import { queryClient } from '../queryClient';

import { createChannelProgramsQueryOptions } from './queryOptions';

export type FetchChannelProgramsQueryArgs = {
  channelId: number;
  day: string;
};

export async function fetchChannelProgramsQuery({ channelId, day }: FetchChannelProgramsQueryArgs) {
  return queryClient.fetchQuery(createChannelProgramsQueryOptions(channelId, day));
}
